export default __webpack_public_path__ + "static/champion-htf-lightweight-webfont-dbb304ba4080b86186fc9e10f9cdf3be.woff";